export { Interpolation } from "./Interpolation"
export { ValueInterpolation, AnyInterpolation, InterpolationOptions } from "./ValueInterpolation"
export { NumberInterpolation } from "./NumberInterpolation"
export { ObjectInterpolation } from "./ObjectInterpolation"
export { NoInterpolation } from "./NoInterpolation"
export { ColorInterpolation } from "./ColorInterpolation"
